/* PRIVATE PART */
interface IValuesResponse {
  fieldRelated: string | undefined;
  value: any;
  checkbox?: boolean;
}
const notChangeField = undefined;

const valueRelatedInput = (context: any, name: string, value: any, checkbox?: boolean) => {
  const inputComponent: any = context?.inputs?.find((a: any) => a.props.name === name && a._isMounted);
  if (inputComponent) {
    const toState = { value: value } as any;
    if (checkbox) toState.checked = value === "true" ? true : false;
    inputComponent.setState(toState);
  }
};
/* END PRIVATE PART */

/* BASE FUNCTION PART */
export async function checkValueInput(inputComponent: any, context: any) {
  const relatedValues = inputComponent.props.valueRelated || [];
  for (const relatedValue of relatedValues) {
    if (typeof relatedValue === "string") {
      let valueRelated: IValuesResponse;
      switch (relatedValue) {
        case "checkConfidential":
          valueRelated = checkedConfidential(inputComponent, context, relatedValue);
          break;
        default:
          valueRelated = { fieldRelated: notChangeField, value: "" };
      }

      if (typeof valueRelated?.fieldRelated !== "undefined") {
        // Change value of the related field
        valueRelatedInput(context, valueRelated.fieldRelated, valueRelated.value, valueRelated?.checkbox);
      }
    }
  }
}
/* END BASE FUNCTION PART */

const checkedConfidential = (input: any, _context: any, type: string) => {
  let result: IValuesResponse = { fieldRelated: undefined, value: "", checkbox: true };
  const value = input.state.value;
  if (value === "talentPool") {
    result.value = "true";
    result.fieldRelated = "dataConfidential"; // Only check when is talent pool
  }
  return result;
};
